/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Delivery_Board_Mins_AgoInputs */

const en_delivery_board_mins_ago = /** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} mins ago`)
};

const es_delivery_board_mins_ago = /** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hace ${i?.min} mins`)
};

const fr_delivery_board_mins_ago = /** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`il y a ${i?.min} mins`)
};

const de_delivery_board_mins_ago = /** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.min} Min.`)
};

const id_delivery_board_mins_ago = /** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} mnt lalu`)
};

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const ja_delivery_board_mins_ago = en_delivery_board_mins_ago;

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const zh_delivery_board_mins_ago = en_delivery_board_mins_ago;

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const ar_delivery_board_mins_ago = en_delivery_board_mins_ago;

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const it_delivery_board_mins_ago = en_delivery_board_mins_ago;

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const ru_delivery_board_mins_ago = en_delivery_board_mins_ago;

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const pt_delivery_board_mins_ago = en_delivery_board_mins_ago;

/** @type {(inputs: Delivery_Board_Mins_AgoInputs) => LocalizedString} */
const ko_delivery_board_mins_ago = en_delivery_board_mins_ago;

/**
* | output |
* | --- |
* | "{min} mins ago" |
*
* @param {Delivery_Board_Mins_AgoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_mins_ago = /** @type {((inputs: Delivery_Board_Mins_AgoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Mins_AgoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_mins_ago(inputs)
	if (locale === "es") return es_delivery_board_mins_ago(inputs)
	if (locale === "fr") return fr_delivery_board_mins_ago(inputs)
	if (locale === "de") return de_delivery_board_mins_ago(inputs)
	if (locale === "ja") return ja_delivery_board_mins_ago(inputs)
	if (locale === "zh") return zh_delivery_board_mins_ago(inputs)
	if (locale === "ar") return ar_delivery_board_mins_ago(inputs)
	if (locale === "id") return id_delivery_board_mins_ago(inputs)
	if (locale === "it") return it_delivery_board_mins_ago(inputs)
	if (locale === "ru") return ru_delivery_board_mins_ago(inputs)
	if (locale === "pt") return pt_delivery_board_mins_ago(inputs)
	return ko_delivery_board_mins_ago(inputs)
});